export const SUSEP_CODE = Object.freeze({ BP_SEGURADORA: '1546' });
